import styled from 'styled-components';

export const ModalBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border);
  padding: 20px;
  border-radius: 8px;
  width: 600px;
  max-height: 50vh;
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  margin-bottom: 16px;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  border: 1px solid var(--border);
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: var(--text);

  thead {
    background: var(--surface-2);
  }

  th {
    padding: 8px;
    text-align: left;
    position: sticky;
    top: 0;
    background: var(--surface-2);
    color: var(--text-muted);
    border-bottom: 1px solid var(--border);
    z-index: 2;
  }

  td {
    padding: 8px;
    border-bottom: 1px solid var(--border);
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const ActionsContainer = styled.div`
  margin-top: 16px;
  text-align: right;
`;
